import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router-dom'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {getCurrentLocale} from 'service/LocaleService';

class InternalLink extends Component {

    static propTypes = {
        to: PropTypes.string.isRequired,
    };

    render() {

      const {to, children, ...otherProps} = this.props;
      const locale = getCurrentLocale();

      let appendSlash = to !=="" && to !=="/" && to.charAt(0)!=='/';

      return (
          <Link to={`/${locale}${appendSlash?'/':''}${to!=='/'?to:''}`} {...otherProps}>{children}</Link>
      );
    }
}

function mapStateToProps(state, props) {
  return {

  }
}

function mapDispatchToProps(dispatch) {
  return {
    //uiActions: bindActionCreators(UIActions, dispatch),
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InternalLink)



// WEBPACK FOOTER //
// ./src/components/views/internalLink/InternalLink.js